var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValuePlusInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.34615 14.6538C2.63846 13.9462 3.10769 12.4615 2.74615 11.5923C2.38462 10.7231 1 9.96154 1 9C1 8.03846 2.36923 7.30769 2.74615 6.40769C3.12308 5.50769 2.63846 4.05385 3.34615 3.34615C4.05385 2.63846 5.53846 3.10769 6.40769 2.74615C7.27692 2.38462 8.03846 1 9 1C9.96154 1 10.6923 2.36923 11.5923 2.74615C12.4923 3.12308 13.9462 2.63846 14.6538 3.34615C15.3615 4.05385 14.8923 5.53846 15.2538 6.40769C15.6154 7.27692 17 8.03846 17 9C17 9.96154 15.6308 10.6923 15.2538 11.5923C14.8769 12.4923 15.3615 13.9462 14.6538 14.6538C13.9462 15.3615 12.4615 14.8923 11.5923 15.2538C10.7231 15.6154 9.96154 17 9 17C8.03846 17 7.30769 15.6308 6.40769 15.2538C5.50769 14.8769 4.05385 15.3615 3.34615 14.6538Z",
    stroke: "#737A83",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3845 7.15396L7.86908 11.4617L5.61523 9.30781",
    stroke: "#737A83",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuePlusInactive);
export default __webpack_public_path__ + "static/media/value-plus-inactive.d671cc49f564de6f8fb2ee53573593c8.svg";
export { ForwardRef as ReactComponent };